import { adminConstants } from '../constants';
import { Cookies } from "react-cookie";
import { cookieConstants } from "../constants";

const cookies = new Cookies();
const currentUser = cookies.get(cookieConstants.USER);
const isSuperAdmin = !!(currentUser && currentUser.role === 'super-admin');

export function admins(state = {}, action) {
  switch (action.type) {
    case adminConstants.GETALL_REQUEST:
      return {
        ...state,
        loading: true
      };
    case adminConstants.GETALL_SUCCESS:
      return {
        ...state,
        items: action.items,
        total: action.total,
        loading: false
      };
    case adminConstants.GETALL_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };
    default:
      return state;
  }
}

export function AddAdmin(state = {}, action) {
  switch (action.type) {
    case adminConstants.ADD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case adminConstants.ADD_SUCCESS:
      return {
        ...state,
        status: action.status,
        loading: false
      };
    case adminConstants.ADD_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
        status: false
      };
    default:
      return state;
  }
}

export function GetAdmin(state = {}, action) {
  switch (action.type) {
    case adminConstants.GET_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case adminConstants.GET_SUCCESS:
      return {
        ...state,
        item: action.item,
        loading: false
      };
    case adminConstants.GET_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
}

export function UpdateAdmin(state = {}, action) {
  switch (action.type) {
    case adminConstants.UPDATE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case adminConstants.UPDATE_SUCCESS:
      return {
        ...state,
        status: action.status,
        loading: false
      };
    case adminConstants.UPDATE_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
        status: false
      };
    default:
      return state;
  }
}

export function acl(state = { loaded: isSuperAdmin, superAdmin: isSuperAdmin, actions: [] }, action) {
  switch (action.type) {
    case adminConstants.ACL_READY:
      return {
        loaded: true,
        superAdmin: action.superAdmin,
        actions: action.actions || [],
      };
    default:
      return state;
  }
}
